import { useRef } from "react";
import Select, { components } from "react-select";
import $ from "jquery";

export const MultiSelect = ({label, options, selectedValues, onChange, wcagMode}) => {

    const multiSelectRef = useRef(null);

    const LimitedChipsContainer = ({ children, hasValue, ...props }) => {
    if (!hasValue) {
      return (
        <components.ValueContainer {...props}>
          {children}
        </components.ValueContainer>
      );
    }
    var displayNames = []
    const CHIPS_LIMIT = 20;
    const [chips, otherChildren] = children;
    const overflowCounter1 = chips.length;
    const overflowCounter = chips.slice(CHIPS_LIMIT).length;
    const displayChips = chips.slice(
      overflowCounter,
      overflowCounter + CHIPS_LIMIT
    );
    displayChips.map((chip)=>{
      if(chip.props.children !== 'Check All'){
      displayNames.push(chip.props.children)
    }
      if(chip.props.children?.length === 0){
        displayNames = 'none'
      }

    })
    $(".language-dropdown span:first").attr("aria-label", displayNames.length + " selected - " + displayNames + ". Press down arrow key to open the menu and select/unselect options.");
    return (
      <components.ValueContainer {...props}>

        <div id="selected-lang-container" style={{marginTop: "-28px"}} role="status" aria-label={displayNames + ' selected'} >{overflowCounter1 > 0 && ` ${overflowCounter1 } selected`}</div>

        {otherChildren}
      </components.ValueContainer>
    );
  };
  const IndicatorsContainer = (props) => {
    return (
      <div style={{ marginLeft: "10px" }}>
        <components.IndicatorsContainer {...props} />
      </div>
    );
  };
  const CustomClearText = () => '';

  const ClearIndicator = (props) => {
    const {
      children = <CustomClearText />,
      innerProps: { ref, ...restInnerProps },
    } = props;
    return (
      <div {...restInnerProps} ref={ref}>
        {children}
      </div>
    );
  };
  const Option = (props) => {
    return props.data.value !== "all" && props.data.value !== "none" ? (
      <components.Option {...props}>
        <input
          tabIndex={0}
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
          id={props.label}
        />{" "}
        <label htmlFor={props.label}>{props.label}</label>
      </components.Option>
    ) : (
      <components.Option {...props}>
        <label
          style={{ fontWeight: 600, fontSize: "14px" }}
          htmlFor={props.label}
        >
          {props.label}
        </label>
        <button
          style={{
            fontWeight: 600,
            fontSize: "14px",
            display: "none",
            color: wcagMode ? "#fff" : "#000",
          }}
          aria-label={props.label}
        >
          {" "}
          {props.label}{" "}
        </button>
      </components.Option>
    );
  };

  const handleInputChange = (e) => {
      if(e.length > 0) {
        $("#selected-lang-container").addClass("display-none");
      } else {
        $("#selected-lang-container").removeClass("display-none");
      }
  }

  const handleChange = (e) => {
    if(onChange){
        onChange(e);
    }

    setTimeout(function() {
        multiSelectRef.current?.focus();
    }, 2000);
  }

  return (
		<Select className="global-dropdown-select lastOutFocus" classNamePrefix='cw' aria-label={label+" Selection"}
		    ref={multiSelectRef}
            isMulti={true}
            hideSelectedOptions={false}
            closeMenuOnSelect={true}
            isClearable={true}
            menuShouldScrollIntoView={false}
            options={options}
            value={selectedValues}
            onChange={handleChange}
            onInputChange={(e) => handleInputChange(e)}
            components={{
                ValueContainer: LimitedChipsContainer,
                Option,
                ClearIndicator,
                IndicatorsContainer,
            }}
        />
   );
}
